import { Inject, Injectable } from '@angular/core';
import { CountryStateServiceInterface, CountryStateServiceInterfaceToken, Country, State } from './interfaces';
import { Observable } from 'rxjs';

export const COUNTRIES_WITH_OPTIONAL_STATES: string[] = ['GB', 'FR', 'DE', 'MT', 'ZA', 'BS', 'BM', 'HK', 'PR'];

@Injectable()
export class CountryStateService implements CountryStateServiceInterface {
  constructor(@Inject(CountryStateServiceInterfaceToken) private innerService: CountryStateServiceInterface) {}
  getCountriesOptions(): Observable<Country[]> {
    return this.innerService.getCountriesOptions();
  }

  getStatesOptions(countryCode: string): Observable<State[]> {
    return this.innerService.getStatesOptions(countryCode);
  }
}
